// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { Input } from './input';

type Props = {
  children: Node,
};

export function Select({ children, ...rest }: Props): Node {
  return (
    <StyledSelectRoot>
      <Input {...rest} as="select">{children}</Input>

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 21l-12-18h24z" />
      </svg>
    </StyledSelectRoot>
  );
}

export const StyledSelectRoot = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 16px;
    top: 50%;
    height: 8px;
    width: auto;
    margin-top: -4px;
    fill: #999;
    pointer-events: none;
  }
`;

export const SelectOption = styled.option``;
